import cs from 'classnames';
import type { ContentObject, ContentObjectView } from 'models';
import { Card, Col, Row } from 'ui';
import { ContentObjectHeader } from '../content-object-header';
import { ContentObjectPreviewBody } from './content-object-preview-body';

type P = {
  item: ContentObject;
  view: ContentObjectView;
};

const ContentObjectPreview = ({ item, view }: P) => (
  <Card className={cs('content-object-preview')} marginBottom={false} variant="outlined">
    <Row gutter={[0, 'ms']}>
      <Col span={24}>
        <ContentObjectHeader item={item} view={view} />
      </Col>
      <Col span={24}>
        <ContentObjectPreviewBody item={item} view={view} />
      </Col>
    </Row>
  </Card>
);

export default ContentObjectPreview;
